import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const styles = (theme) => ({
  actionButton: {},
  submitButton: {
    "&$disabledButton": {
      backgroundColor: theme.headerIconColor,
      color: theme.TextColor,
    },
  },
  disabledButton: {},
});

const PickupDialogActions = ({
  classes,
  handleSubmit,
  handleClose,
  submitDisabled,
  isNoFreight,
}) => {
  return (
    <>
      <Button
        autoFocus
        onClick={handleClose}
        color="primary"
        variant="outlined"
        className={classes.actionButton}
      >
        Close
      </Button>

      {!isNoFreight && (
        <Button
          autoFocus
          color="primary"
          variant="contained"
          classes={{
            root: classes.submitButton,
            disabled: classes.disabledButton,
          }}
          onClick={() => handleSubmit("pickup")}
          disabled={submitDisabled}
        >
          Pickup Done
        </Button>
      )}
      {isNoFreight && (
        <Button
          autoFocus
          color="primary"
          variant="contained"
          className={classes.submitButton}
          onClick={() => handleSubmit("noFreight")}
        >
          No Freight Entry
        </Button>
      )}
    </>
  );
};
export default withStyles(styles)(PickupDialogActions);
